module.exports = __webpack_public_path__ + "img/thumbnail_Ocelot_j_leucistic.580d5533.png";